// src/pages/.../ManageMembers/components/ManageMembersToolbar.jsx

import React from "react";

import {
  FaFileExcel,
  FaPlus,
  FaSearch,
} from "react-icons/fa";

import { MdFolderShared } from "react-icons/md";

import { cn } from "../utils/manageMembers.utils";

export default function ManageMembersToolbar({
  searchTerm,
  selectedDojo,
  selectedGroup,

  dojos,
  filteredGroups,

  demoMode,
  hasReachedLimit,
  hasAdherents,

  onSearchChange,
  onDojoChange,
  onGroupChange,

  onAdd,
  onImport,
  onExportSelectedGroup,
  onExportAllGroups,
}) {
  const addAndImportDisabled =
    demoMode || hasReachedLimit;

  return (
    <section className="mt-6 rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="flex flex-col gap-5">
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-[minmax(260px,1fr)_220px_240px]">
          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500" />

            <input
              type="text"
              placeholder="Rechercher un adhérent..."
              value={searchTerm}
              onChange={(event) =>
                onSearchChange(event.target.value)
              }
              className="w-full rounded-2xl border border-slate-200 bg-white py-3 pl-11 pr-4 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-blue-500 focus:ring-4 focus:ring-blue-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:placeholder:text-slate-500 dark:focus:border-blue-400 dark:focus:ring-blue-500/20"
            />
          </div>

          <select
            value={selectedDojo}
            onChange={(event) =>
              onDojoChange(event.target.value)
            }
            className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:focus:border-blue-400 dark:focus:ring-blue-500/20"
          >
            <option value="">Tous les lieux</option>

            {dojos.map((dojo) => (
              <option key={dojo.id} value={dojo.id}>
                {dojo.nom_dojo}
              </option>
            ))}
          </select>

          <select
            value={selectedGroup}
            onChange={(event) =>
              onGroupChange(event.target.value)
            }
            className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:focus:border-blue-400 dark:focus:ring-blue-500/20"
          >
            <option value="">Tous les groupes</option>

            {filteredGroups.map((group) => (
              <option key={group.id} value={group.id}>
                {group.nom_groupe}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-wrap gap-3">
          <button
            type="button"
            onClick={onAdd}
            disabled={addAndImportDisabled}
            className={cn(
              "inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-3 font-semibold text-white transition",
              addAndImportDisabled
                ? "cursor-not-allowed bg-slate-400 dark:bg-slate-700"
                : "bg-emerald-600 hover:bg-emerald-700 dark:bg-emerald-500 dark:hover:bg-emerald-600",
            )}
          >
            <FaPlus />
            Ajouter
          </button>

          <button
            type="button"
            onClick={onImport}
            disabled={addAndImportDisabled}
            className={cn(
              "inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-3 font-semibold text-white transition",
              addAndImportDisabled
                ? "cursor-not-allowed bg-slate-400 dark:bg-slate-700"
                : "bg-amber-500 hover:bg-amber-600 dark:bg-amber-500 dark:hover:bg-amber-600",
            )}
          >
            <MdFolderShared className="text-xl" />
            Importer
          </button>

          <button
            type="button"
            onClick={onExportSelectedGroup}
            disabled={!selectedGroup}
            title={
              selectedGroup
                ? "Exporter les adhérents du groupe sélectionné"
                : "Sélectionnez d'abord un groupe"
            }
            className={cn(
              "inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-3 font-semibold text-white transition",
              !selectedGroup
                ? "cursor-not-allowed bg-slate-400 dark:bg-slate-700"
                : "bg-green-600 hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600",
            )}
          >
            <FaFileExcel />
            Exporter le groupe
          </button>

          <button
            type="button"
            onClick={onExportAllGroups}
            disabled={!hasAdherents}
            className={cn(
              "inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-3 font-semibold text-white transition",
              !hasAdherents
                ? "cursor-not-allowed bg-slate-400 dark:bg-slate-700"
                : "bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600",
            )}
          >
            <FaFileExcel />
            Exporter tous les groupes
          </button>
        </div>
      </div>
    </section>
  );
}